import { MutableRefObject, useEffect, useState } from 'react'

import { MenuPlacement } from 'react-select'

import { MENU_HEIGHT } from '../utils/utils'

export const useMenuPlacement = (
  scrollViewRef: MutableRefObject<HTMLDivElement>,
  menuRef: MutableRefObject<HTMLDivElement>
) => {
  const [menuPlacement, setMenuPlacement] = useState<MenuPlacement>('auto')

  const calculateMenuPlacement = () => {
    const parentHeight = scrollViewRef.current?.clientHeight
    const menuContainerPositionY = menuRef.current?.getBoundingClientRect().y
    if (menuContainerPositionY + MENU_HEIGHT > parentHeight) {
      setMenuPlacement('top')
    } else {
      setMenuPlacement('auto')
    }
  }

  useEffect(() => {
    window.addEventListener('resize', calculateMenuPlacement)
    return () => window.removeEventListener('resize', calculateMenuPlacement)
  }, [])

  useEffect(() => {
    calculateMenuPlacement()
  }, [scrollViewRef, menuRef])

  return menuPlacement
}
